export default __webpack_public_path__ + "static/media/skovstykket-tenancy-01.eaea3303.jpg";